<template>
  <modal :name="modalName" height="auto" :scrollable="true">
    <form
      id="show-application-modal"
      @submit.prevent="onSubmit()"
      :data-vv-scope="formScope"
    >
      <div class="modal-header">
        <h5 class="modal-title">
          <span v-if="!application.id && !applicationParent">New Application</span>
          <span v-if="!application.id && applicationParent">New Application in {{applicationParent.title}}</span>
          <span v-if="application.id">Edit application</span>
        </h5>
        <button type="button" class="close" @click="$modal.hide(modalName)"><i class="fas fa-times"></i></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <base-text :errorsNextLine="true" name="name" v-validate="'required'" label="Application name" v-model="application.name"
                       :err="errors.collect('name', formScope)" :focus="true"></base-text>

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <base-button radius="bl" component-class="blue" @click.native="$modal.hide(modalName)">
          Close
        </base-button>
        <base-button radius="br" component-class="green filled" type="submit">
          Save
        </base-button>
      </div>
    </form>
  </modal>
</template>

<script>

  import BaseButton from '../../../../components/inputs/button/BaseButton';
  import BaseText from '../../../../components/inputs/text/BaseText';

  export default {
    name: 'ShowApplicationModal',
    components: {
      BaseButton, BaseText
    },
    data () {
      return {
        modalName: 'show-application',
        formScope: 'applicationForm'
      };
    },
    methods: {
      onSubmit() {
        this.$validator.validateAll(this.formScope).then(result => {
          if (result) {
            if (this.applicationParent) {
              this.application.parent_id = this.applicationParent.data.id;
            }
            this.$store.dispatch('applications/save').then(() => {
              this.$store.dispatch('applications/getApplications');
              this.$modal.hide(this.modalName);
            });
          }
        });
      }
    },
    computed: {
      application: {
        get () {
          return this.$store.getters['applications/current'];
        },
        set (value) {
          this.$store.dispatch('applications/current', value);
        }

      },
      applicationParent() {
        return this.$store.getters['applications/applicationParent'];
      }
    }
  };

</script>

<style scoped>

</style>